//List Showtime
export const LIST_SHOWTIME_REQUEST =
  "listShowTimeReducer/LIST_SHOWTIME_REQUEST";
export const LIST_SHOWTIME_SUCCESS =
  "listShowTimeReducer/LIST_SHOWTIME_SUCCESS";
export const LIST_SHOWTIME_FAILED = "listShowTimeReducer/LIST_SHOWTIME_FAILED";
export const CHANGE_SHOWTIME_LIST = "listShowTimeReducer/CHANGE_SHOWTIME_LIST";
export const CHANGE_CINEMA_LIST = "listShowTimeReducer/CHANGE_CINEMA_LIST";
